"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authentication = void 0;
const tslib_1 = require("tslib");
const base_1 = tslib_1.__importDefault(require("../base"));
const utils_1 = tslib_1.__importDefault(require("../utils"));
class Authentication extends base_1.default {
    /**
     * Authenticate a previously registered user through FIDO2.
     * @deprecated This method is deprecated, use `authenticateWithFido2` instead
     * */
    login(username, options = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.authenticateWithFido2(username, options);
            return {
                uid: result.credential.uuid,
                username: result.user.username,
                namespace: result.user.namespace_id,
                jwt: result.jwt,
                user: {
                    id: result.user.id,
                    type: result.user.type,
                }
            };
        });
    }
    /**
     * Authenticate a previously registered user through FIDO2.
     * @returns {Promise<Result>}
     * */
    authenticateWithFido2(username, options = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let headers;
            if (options && options.authorization_token) {
                headers = { Authorization: `Bearer ${options.authorization_token}` };
                delete options.authorization_token;
            }
            // Init the authentication flow
            let initPayload = {
                client_id: this._clientID,
                username,
            };
            let initResponse = yield utils_1.default.http.post(this._baseURL, "/authenticate/fido2/init", initPayload, headers);
            // Process the authenticate init response and request the credential from the browser
            const { assertion_payload: assertionPayload } = initResponse;
            const { challenge } = assertionPayload;
            assertionPayload.challenge = utils_1.default.encoding.base64ToBuffer(assertionPayload.challenge);
            if (assertionPayload.allowCredentials) {
                for (const credential of assertionPayload.allowCredentials) {
                    credential.id = utils_1.default.encoding.base64ToBuffer(credential.id);
                }
            }
            const credential = yield utils_1.default.navigator.getCredential({ publicKey: assertionPayload });
            const response = credential.response;
            // Complete the authentication flow
            const completePayload = {
                client_id: this._clientID,
                username,
                assertion_payload: {
                    challenge,
                    credential_id: utils_1.default.encoding.bufferToBase64(credential.rawId),
                    client_data: utils_1.default.encoding.bufferToBase64(response.clientDataJSON),
                    authenticator_data: utils_1.default.encoding.bufferToBase64(response.authenticatorData),
                    signature: utils_1.default.encoding.bufferToBase64(response.signature),
                }
            };
            return yield utils_1.default.http.post(this._baseURL, "/authenticate/fido2/complete", completePayload);
        });
    }
    /**
     * Authenticate a previously registered user using username and password.
     * @returns {Promise<Result>}
     * */
    authenticateWithPassword(username, password, options = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let headers;
            if (options && options.authorization_token) {
                headers = { Authorization: `Bearer ${options.authorization_token}` };
                delete options.authorization_token;
            }
            // Create the request payload.
            const payload = {
                client_id: this._clientID,
                username,
                password,
            };
            return yield utils_1.default.http.post(this._baseURL, "/authenticate/password", payload, headers);
        });
    }
    /**
     * Authenticate a previously registered user through Verify.
     * @returns {Promise<Result>}
     * */
    authenticateWithVerify(username, element, options = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let headers;
            if (options && options.authorization_token) {
                headers = { Authorization: `Bearer ${options.authorization_token}` };
                delete options.authorization_token;
            }
            // Init the login flow
            let initPayload = {
                client_id: this._clientID,
                username,
            };
            // Check for payload options before sending the request.
            if (options && options.credential_uuid) {
                initPayload.options = { credential_uuid: options.credential_uuid };
            }
            let initResponse = yield utils_1.default.http.post(this._baseURL, "/authenticate/authid/init", initPayload, headers);
            yield utils_1.default.authidIframeHandler(element, initResponse.iframe_url);
            // Complete the authentication flow
            const completePayload = {
                client_id: this._clientID,
                username,
                credential_uuid: initResponse.credential_uuid
            };
            return yield utils_1.default.http.post(this._baseURL, "/authenticate/authid/complete", completePayload);
        });
    }
    /**
     * Self-serve code genearation for add credential and/or temporary login
     * @returns {Promise<SelfGenerateCodeResult>}
     * */
    selfGenerateCode(username, codeType, purpose, options = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let headers;
            if (options && options.authorization_token) {
                headers = { Authorization: `Bearer ${options.authorization_token}` };
                delete options.authorization_token;
            }
            // Create the request payload.
            const payload = {
                client_id: this._clientID,
                username,
                purpose: purpose,
                options
            };
            const initResponse = yield utils_1.default.http.post(this._baseURL, `/codes/${codeType}/generate/fido2/init`, payload, headers);
            // process the init response and request the credential from the browser
            const { assertion_payload: assertionPayload } = initResponse;
            const { challenge } = assertionPayload;
            assertionPayload.challenge = utils_1.default.encoding.base64ToBuffer(assertionPayload.challenge);
            if (assertionPayload.allowCredentials) {
                for (const credential of assertionPayload.allowCredentials) {
                    credential.id = utils_1.default.encoding.base64ToBuffer(credential.id);
                }
            }
            const credential = yield utils_1.default.navigator.getCredential({ publicKey: assertionPayload });
            const response = credential.response;
            // Construct the complete payload from credential request response
            const completePayload = {
                client_id: this._clientID,
                username,
                assertion_payload: {
                    challenge,
                    credential_id: utils_1.default.encoding.bufferToBase64(credential.rawId),
                    client_data: utils_1.default.encoding.bufferToBase64(response.clientDataJSON),
                    authenticator_data: utils_1.default.encoding.bufferToBase64(response.authenticatorData),
                    signature: utils_1.default.encoding.bufferToBase64(response.signature),
                }
            };
            // Complete the authentication flow and return the code
            return yield utils_1.default.http.post(this._baseURL, `/codes/${codeType}/generate/fido2/complete`, completePayload);
        });
    }
}
exports.Authentication = Authentication;
exports.default = Authentication;
//# sourceMappingURL=index.js.map